import React from 'react';
import Sorting from './Sorting';
import { Input, TextField, MenuItem, FormControl, InputLabel, Typography, Select, Switch } from '@mui/material';
import _ from 'lodash';
import '../css/regokas.css';
import Edit from '../images/headericon/Edit.svg';
import Success from '../images/Success.svg';
import Error from '../images/Error.svg';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    IconButton,
} from "@mui/material";
import Loader from '../components/loader';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import errorText from '../errorText';
import SearchBar from './SearchBar';
import SnackBar from '../containers/SnackBar';
import Style from 'style-it';
import { AiOutlinePlus } from 'react-icons/ai';
import { RxCross2 } from 'react-icons/rx';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Box } from '@mui/system';
import { is_allowed } from '../utils';

class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fullName: "",             // Full Name input
            fullNameError: false,     // Validation for Full Name
            userListReversData: [],
            roles: "",               // Selected role ID from dropdown
            roleData: [],
            usersList: [],           // List of roles fetched from backend
            officelocation: "",       // Seems redundant, but used in your current onChange
            officelocationerror: false,
            email: "",                // User's email input
            emailerror: false,        // Validation for email input
            selectedUser: [],         // Assigned user selected from dropdown
            userError: false,
            topHeightModal: '0%',
            roleData: [],
            confirmWindow: false,
            kk: 'asdvhj',
            phone: '',
            name: '',
            officelocation: '',
            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            classshowofmodal: false,
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            searchbar: '',
            opensearch1: 0,
            loader: '',
            currentPage: 1,
            todosPerPage: 10,
            okasBoxData: [],
            statuson: false, statustw: false, statusth: false,
            statusfo: false, statusfi: false, statussi: false,
            statusse: false, statusei: false, statusni: false,
            statuste: false,
            indianCityWithState: [],
            showError: false,
            otherlocation: '',
            snackbarActive: false
        };
        // this.handleClickpage = this.handleClickpage.bind(this);
    }

    confirmWindowClose = () => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            confirmWindow: false
        })
    }

    opensearch = (data) => {
        if (data == 0)
            this.setState({
                opensearch1: 1,
            });
        else
            this.setState({
                opensearch1: 0,
            });
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getallrealdata();
    }

    //------------------------------------------------ error msg function start--------------------------------------------------------
    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }
    //------------------------------------------------ error msg function end ------------------------------------------------

    // ------------------------------------------------main data get API start------------------------------------------------
    getallrealdata = () => {
        this.setState({ loader: true });

        const TokenValue = 'Token ' + localStorage.getItem("auth");
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        };

        // Fetch roles
        const fetchRoles = fetch('/we/addRoles/', {
            method: "GET",
            headers: headers
        }).then(res => res.json());

        // Fetch users
        const fetchUsers = fetch('/we/addUsers/', {
            method: "GET",
            headers: headers
        }).then(res => res.json());

        // Wait for both to complete
        Promise.all([fetchRoles, fetchUsers])
            .then(([roleData, userData]) => {
                this.setState({
                    roleData,
                    actualdata: roleData,
                    usersList: userData, // 👈 New state for storing fetched users
                    userListReversData: userData,
                    loader: false
                }, () => {
                    this.renderTableData();
                });

            })
            .catch(error => {
                this.setState({ loader: false });
            });
    }

    //------------------------------------------------ main data get API end------------------------------------------------



    ondeleteChangekHandler = (pmids) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            confirmWindow: true
        })
        if (true) {
            this.setState({
                loader: true,
            })
            let TokenValue = 'Token ' + localStorage.getItem("auth");
            var headers = {
                'Content-Type': 'application/json',
                'Authorization': TokenValue,
                'X-CSRFToken': localStorage.getItem('csrftoken')

            }
            fetch('/we/we/locationApi_detail/' + this.state.officeLocationToDelete, {
                method: "DELETE",
                headers: headers,
            })
                .then(response => {
                    response.json();
                    if (response.status == 200) {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                        })
                        this.getallrealdata();
                        this.oncolseClickHandler();
                        this.errormsg();
                    } else {
                        this.setState({
                            snackbarMessage: 'Office location can not deleted.',
                            snackbarActive: true,
                        })
                    }
                    this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
                    this.setState({
                        loader: false,
                        confirmWindow: false,

                    })
                })
        }
    }

    handleClickpage(number) {
        this.setState({
            currentPage: number,
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }

    handleEditIcon(details) {

        this.onopenmodel()
        this.setState({ fullName: details.name, roles: details.role.role_id, email: details.user_email, selectedUser: details.role_assigned, user_id: details.id })
    }

    handleDeleteIcon(details) {
        const is_confirmed = window.confirm("are you sure you want to delete ?")

        if (is_confirmed) {
            let TokenValue = 'Token ' + localStorage.getItem("auth");
            var headers = {
                'Content-Type': 'application/json',
                'Authorization': TokenValue,
                'X-CSRFToken': localStorage.getItem('csrftoken')

            }
            fetch(`/we/we/addUsers_detail/${details.id}`, {
                method: "DELETE",
                headers: headers,
            }).then(() => {
                alert("User Deleted")
                window.location.reload()

            }).catch(e => alert("Unable to delete user"))
        }
    }

    handleDeleteUser() {

    }
    //------------------------------------------------ print main data(List view) function start----------------------------
    renderTableData = (type) => {
        // console.log(this.state.usersList);
        if (this.state.usersList == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }
        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.usersList.slice(indexOfFirstTodo, indexOfLastTodo);
        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.usersList.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }

            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage.bind(this, number)}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }
        if (type === 'type1') {
            console.log(currentTodos)
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                typee = typee + 1;
                let offloc = e.ID;
                return (
                    <tr key={index}>
                        {/* <td>{index + 1}</td> */}
                        <td className={this.props.windowWidth > 760 ? "qwerty" : ""}>{(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + index + 1}</td>
                        <td>{e.name}</td>
                        <td>{e.role?.name}</td>
                        <td>{e.user_email}</td>
                        <td>{e.role_assigned}</td>
                        <td>{e.role_created_by}</td>
                        {(is_allowed(
                            this.props.redux.permissions.permissions?.[0],
                            localStorage.getItem("name"),
                            "user",
                            "edit"
                        ) || is_allowed(
                            this.props.redux.permissions.permissions?.[0],
                            localStorage.getItem("name"),
                            "user",
                            "delete"))
                            && (
                                <td className={this.props.windowWidth > 760 ? "qwerty" : ""}>
                                    <div>
                                        {is_allowed(
                                            this.props.redux.permissions.permissions?.[0],
                                            localStorage.getItem("name"),
                                            "user",
                                            "edit"
                                        ) && <img
                                                src={Edit}
                                                onClick={() => {
                                                    this.handleEditIcon(e)
                                                }}
                                                style={{ cursor: 'pointer' }}
                                            />}
                                        {is_allowed(
                                            this.props.redux.permissions.permissions?.[0],
                                            localStorage.getItem("name"),
                                            "user",
                                            "delete"
                                        ) &&
                                            <Switch
                                                checked={e.status === 1}
                                                onChange={() =>
                                                    this.onAddClickHandlerPUT(null, {
                                                        user_email: e.user_email,
                                                        currentStatus: e.status,
                                                    })
                                                }
                                                color="primary"
                                            />
                                        }
                                    </div>
                                </td>
                            )}
                    </tr>
                )
            });
            return xx;
        }
    }
    //------------------------------------------------ print main data(List view) function end--------------------------------

    //------------------------------------------------ Delete Succ msg start//------------------------------------------------
    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }

    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
            nameerror: '',
        })
    }
    ////------------------------------------------------ Delete Succ msg end//------------------------------------------------

    oncolseClickHandler = (event) => {
        this.setState({
            name: '',
            phone: '',
            email: '',
            officelocation: '',
        })
    }
    // --------------------------------------------------------open model function start----------------------------
    onopenmodel = (event) => {
        this.setState({ fullName: '', roles: null, email: '', selectedUser: '', user_id: null })

        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: 'true',
        })
        this.props.searchBarActivate(false)
        // this.getcitydata();
    }
    // --------------------------------------------------------open model function end-------------------------------

    // --------------------------------------------------------close model function start----------------------------
    onclosemodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: '',
            error: '',
            fullName: '',              // e.g., "Rajat"
            role: '',                // e.g., 2
            email: '',          // e.g., "rajat@rajat.ai"
            selectedUser: ''
        })
    }
    // --------------------------------------------------------close model function End----------------------------


    // ----------------------------Submit all data in data base POST API Start--------------------------------------

    // onAddClickHandler(type) {
    //     const { fullName, roles, email, selectedUser } = this.state;

    //     if (!fullName.trim() || !roles || !email) {
    //         this.setState({ error: "Please fill all required fields" });
    //         return;
    //     }
    //     const jsonData = {
    //         name: fullName,              // e.g., "Rajat"
    //         role: roles,                // e.g., 2
    //         user_email: email,          // e.g., "rajat@rajat.ai"
    //         role_assigned: selectedUser,// e.g., "sumit@vyom.ai"
    //     };

    //     // 👇 Start loader before sending request
    //     this.setState({ loader: true });

    //     fetch(this.state.user_id ? `/we/addUsers_detail/${this.state.user_id}` : "/we/addUsers/", {
    //         method: this.state.user_id ? "PUT" : "POST",
    //         headers: {
    //             "Content-Type": "application/json",
    //             "X-CSRFToken": localStorage.getItem("csrftoken"),
    //         },
    //         body: JSON.stringify(jsonData),
    //     })
    //         .then(response => {
    //             if (response.status === 403) {
    //                 window.location = "/login/session-timeout"
    //             }
    //             return response.json()
    //         })

    //         .then((data) => {
    //             console.log("mmmmmm",data);
    //             if (type === "add") {
    //                 this.setState({
    //                     fullName: "",
    //                     roles: "",
    //                     email: "",
    //                     selectedUser: "",
    //                     error: "",
    //                     successmsgmodaldata: 'dataadded',
    //                     loader: false
    //                 });
    //                 this.onclosemodel(); // Close modal after success
    //                 this.getallrealdata();
    //                 this.errormsg();

    //             }

    //         })
    //         .catch((error) => {
    //             console.error("❌ Error adding user:", error);
    //         });
    // }

    onAddClickHandler(type) {
        const { fullName, roles, email, selectedUser } = this.state;

        if (!fullName.trim() || !roles || !email) {
            this.setState({ error: "Please fill all required fields" });
            return;
        }

        const jsonData = {
            name: fullName,
            role: roles,
            user_email: email,
            role_assigned: selectedUser,
        };

        this.setState({ loader: true });

        fetch(this.state.user_id ? `/we/addUsers_detail/${this.state.user_id}` : "/we/addUsers/", {
            method: this.state.user_id ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": localStorage.getItem("csrftoken"),
            },
            body: JSON.stringify(jsonData),
        })
            .then(response => {
                if (response.status === 403) {
                    window.location = "/login/session-timeout";
                }
                return response.json();
            })
            .then((data) => {
                // console.log("mmmmmm", data);

                // 👇 Handle failure and stop further steps
                if (data.message === "failure") {
                    alert(data.data.Email || "Something went wrong.");
                    this.setState({ loader: false });
                    return;
                }

                if (type === "add") {
                    this.setState({
                        fullName: "",
                        roles: "",
                        email: "",
                        selectedUser: "",
                        error: "",
                        successmsgmodaldata: 'dataadded',
                        loader: false
                    });
                    this.onclosemodel();
                    this.getallrealdata();
                    this.errormsg();
                }
            })
            .catch((error) => {
                console.error("❌ Error adding user:", error);
                this.setState({ loader: false });
            });
    }



    onAddClickHandlerPUT(type, toggleData = null) {
        const { allusers } = this.state;

        if (toggleData) {
            const { user_email, currentStatus } = toggleData;
            const newStatus = currentStatus === 1 ? 0 : 1;

            this.setState({ loader: true });

            fetch('/we/addUsers/', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': localStorage.getItem('csrftoken'),
                },
                body: JSON.stringify({ user_email, status: newStatus }),
            })
                .then(async (response) => {

                    if (response.status === 403) {
                        window.location = "/login/session-timeout";
                        throw new Error('Session expired');
                    }

                    if (!response.ok) {
                        let errorMessage = 'Failed to update status';
                        try {
                            const errData = await response.json();
                            if (errData && errData.message) {
                                errorMessage = errData.message;
                            }
                        } catch (err) {
                        }
                        throw new Error(errorMessage);
                    }

                    const data = await response.json();
                    return data;
                })
                .then(async (data) => {

                    try {
                        await this.getallrealdata();
                        //   console.log('getallrealdata() success');
                    } catch (err) {
                        //   console.error('Error in getallrealdata():', err);
                        // Optionally: You can still proceed or show alert here:
                        // alert('Warning: failed to refresh data after update.');
                    }

                    alert(`User status updated to ${newStatus === 1 ? 'Active' : 'Inactive'}`);
                })
                .catch((error) => {
                    this.setState({ loader: false });
                    alert(`Error updating user status. ${error.message || 'Please try again.'}`);
                });

            return;
        }

        // Handle other add/edit logic...
    }


    //----------------------------------------- Submit all data in data base POST API End----------------------------------------


    //-------------------------------------------Render data after sorting Function Start----------------------------------------------
    restoreData = (data) => {
        this.setState({
            usersList: data,
        })
    }
    //-----------------------------------------------Render data after sorting Function End--------------------------------------------------


    //------------------------------------------------------- sorting Function Start----------------------------------------------
    sortingFunc = (type, searchValue) => {
        if (type !== "search") {
            this.props.searchBarActivate(false)
        }
        if (type == "name") {
            this.setState({
                statuson: !this.state.statuson,
                statustw: false, statusth: false, statusfo: false,
                statusfi: false, statussi: false, statusse: false,
                statusei: false, statusni: false, statuste: false,
            })
        }
        if (type == "phone") {
            this.setState({
                statustw: !this.state.statustw,
                statuson: false, statusth: false, statusfo: false,
                statusfi: false, statussi: false, statusse: false,
                statusei: false, statusni: false, statuste: false,
            })
        }
        if (type == "email") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false, statusth: !this.state.statusth,

            })
        }
        if (type == "under_user") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false, statusfo: !this.state.statusfo,
            })
        }
        if (type == "created_by") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false, statusfi: !this.state.statusfi,
            })
        }
        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.usersList);
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.userListReversData, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.usersList);
        }
    }

    //---------------------------------------------------------- sorting Function End--------------------------------------------------



    handleAddNewRole = () => {

        if (this.props.redux.globalVar.userTypeStyle == '1') {
            window.location.href = '/roles2';
        } else {
            window.location.href = '/roles';
        }
    };


    render() {
        return Style.it(`
        @media only screen and (max-width: 760px){
      td:nth-of-type(1):before { content: "S.NO"; }
      td:nth-of-type(2):before { content: "FULL NAME"; }
      td:nth-of-type(3):before { content: "ROLE"; }
      td:nth-of-type(4):before { content: "EMAIL"; }
      td:nth-of-type(5):before { content: "UNDER USER"; }
      td:nth-of-type(6):before { content: "CREATED BY"; }
      td:nth-of-type(7):before { content: "EDIT"; }
    }`,
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : ""
                }}

            >
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                {this.state.loader ? <Loader /> : null}
                {this.props.redux.globalVar.searchBarShow ?
                    <div className='row searchinput'>

                        <SearchBar
                            autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                            resetSearch={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', '')
                                })
                            }}
                        />
                    </div>
                    : ''}

                <div className="addregOkasButton">
                    {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "user", "add") && <Box
                        component="a"
                        className="addregOkasButtonicon button-custom-height-size"
                        onClick={this.onopenmodel.bind(this)}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#f9f9f9",
                            color: "#94979a",
                            textTransform: "none",
                            padding: "10px 20px",

                        }}
                    >
                        <AiOutlinePlus size={30} style={{ marginRight: 8, color: "#15599F" }} />
                        <span className="hidden-xs hidden-sm button-color">ADD NEW USER</span>
                    </Box>}
                    {/* <Box
                        component="a"
                        href={
                            localStorage.getItem("name") === "1"
                                ? "usertreechart2"
                                : localStorage.getItem("name") === "3"
                                    ? "usertreechart"
                                    : "#"
                        }
                        className="addregOkasButtonicon button-custom-height-size"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#037F94",
                            color: "#94979a",
                            textTransform: "none",
                            padding: "10px 20px",
                            marginRight: '12px'
                        }}
                    >
                        <AiOutlinePlus size={30} style={{ marginRight: 8, color: "white" }} />
                        <span className="hidden-xs hidden-sm button-color" style={{ color: "white" }}>TREE VIEW</span>
                    </Box> */}
                    <div className="hidden-xs hidden-md  hidden-lg button-color sm-heading-btn">Add New User</div>
                </div>
                <div className="row">
                    <h3>Dear {this.props.redux.globalVar.reUserNameStyle}, Listed below are your existing users</h3>
                    <h6 className="mb-3 mt-0">To add a new user click on, "Add New User" </h6>
                    <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                        <div className="inblksuccfull"><img src={Success} /></div>
                        <div className="inblksucc1">
                            SUCCESS !
                            <a className="successmsgcross"><RxCross2 style={{ color: 'white' }} size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                        </div>
                    </div>
                    <div className="tests">
                        <TableContainer component={Paper}>
                            <Table className={"tablecontent"}>
                                <TableHead>
                                    <TableRow>
                                        {[
                                            { key: "sno", label: "S.NO", sx: { width: "10%" } },
                                            { key: "name", label: "NAME", sx: { width: "12%" } },
                                            { key: "phone", label: "ROLE", sx: { width: "12%" } },
                                            { key: "email", label: "EMAIL", sx: { width: "15%" } },
                                            { key: "under_user", label: "UNDER USER", sx: { width: "15%" } },
                                            { key: "created_by", label: "CREATED BY", sx: { width: "15%" } },
                                        ].map((column) => (
                                            <TableCell
                                                key={column.key}
                                                sx={{
                                                    ...column.sx,
                                                    color: "white",
                                                    fontSize: '11px',
                                                }}
                                            >
                                                {column.label}
                                                <IconButton
                                                    style={{ float: "right", cursor: "pointer", color: 'white' }}
                                                    size="small"
                                                    onClick={() => this.sortingFunc(column.key, "")}
                                                >
                                                    {this.state[`status${column.key}`] ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                </IconButton>
                                            </TableCell>
                                        ))}
                                        <TableCell
                                            sx={{
                                                width: "10%",
                                                color: "white",
                                                fontSize: '11px',
                                            }}
                                        >
                                            EDIT
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loader ? <Loader /> : this.renderTableData("type1")}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <div className="pull-right">
                            {this.state.todosPerPage < this.state.usersList.length ?
                                <ul className="pagination pull-right paginat">
                                    <li>
                                        <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - this.state.usersList.length < 0 ? this.state.currentPage * this.state.todosPerPage : this.state.usersList.length}  of {this.state.usersList.length} enteries</span>
                                    </li>
                                    <li>
                                        <a
                                            onClick={this.state.currentPage == - 1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage - 1)
                                            }
                                            aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    </li>
                                    {this.renderTableData('pagination')}
                                    <li className="">
                                        <a className=""
                                            onClick={this.state.currentPage * this.state.todosPerPage == this.state.usersList.length ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage + 1)
                                            }
                                            aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                                : null}
                        </div>
                    </div>
                </div>
                {this.state.showmodels ?
                    <div className="selfmodal fade in modal-dialog-centered" style={{ alignItems: "center", top: this.state.topHeightModal }} aria-hidden="false" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog"
                            style={{
                                width: this.props.windowWidth > 760 ? "50%" : "60%",
                            }}
                        >
                            <div className="selfmodal-content" >
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" onClick={this.onclosemodel.bind(this)}>&times;</button>
                                    <h3 className="modal-title">{this.state.user_id ? "Edit" : "Add"} New User
                                    </h3>
                                    <h6>Please fill in the details to add new user.</h6>
                                    <div className={this.state.error ? 'errormsgbox' : 'errormsgbox errormsgboxnone'} >
                                        <div className="inblksucc"><img src={Error} /></div>
                                        <div className="inblksucc1">
                                            {this.state.error} !
                                            <a className="successmsgcross"><RxCross2 size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body modfields">
                                    <TextField
                                        label="Name of the User"
                                        type="text"
                                        fullWidth
                                        required
                                        variant="standard"
                                        value={this.state.fullName}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const filteredValue = value.replace(/[^a-zA-Z ]/g, '').slice(0, 23); // Only letters & space, max 23
                                            this.setState({ fullName: filteredValue, fullNameError: false });
                                        }}
                                        helperText={
                                            this.state.addresserror
                                                ? "Please enter a valid address"
                                                : `${this.state.fullName.length}/23`
                                        }
                                        onKeyDown={(e) => {
                                            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', ' '];
                                            const key = e.key;
                                            if (
                                                !allowedKeys.includes(key) &&
                                                !/^[a-zA-Z]$/.test(key)
                                            ) {
                                                e.preventDefault(); // Block numbers, special characters, etc.
                                            }
                                        }}
                                        onPaste={(e) => {
                                            const pastedData = e.clipboardData.getData('text');
                                            if (!/^[a-zA-Z ]+$/.test(pastedData)) {
                                                e.preventDefault(); // Block pasting invalid characters
                                            }
                                        }}
                                        sx={{
                                            '& label.MuiFormLabel-root': {
                                                '& .MuiInputLabel-asterisk': {
                                                    color: 'red', // Red required star
                                                },
                                            },
                                        }}
                                        style={{ marginBottom: "10px" }}
                                    />

                                    <br />
                                    <TextField
                                        required
                                        label="Group"
                                        select
                                        fullWidth
                                        variant="standard"
                                        value={this.state.roles}
                                        onChange={(e) => {
                                            if (e.target.value === "add_new") {
                                                // Handle "Add New Manually" case separately
                                                this.handleAddNewRole();
                                            } else {
                                                this.setState({ roles: e.target.value });
                                            }
                                        }}
                                        sx={{
                                            '& label.MuiFormLabel-root': {
                                                '& .MuiInputLabel-asterisk': {
                                                    color: 'red', // 🔴 Change this to your desired color
                                                },
                                            },
                                        }}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        {/* Dummy Role Options */}
                                        {this.state.roleData.map((role, index) => (

                                            <MenuItem key={index} value={role.role_id}>
                                                {role.name}
                                            </MenuItem>
                                        ))}

                                        {/* "Add New Manually" option (acts like a link) */}
                                        <MenuItem key="add_new" value="add_new">
                                            <span style={{ color: "#1976d2", textDecoration: "none", cursor: "pointer" }}>
                                                Add New Manually
                                            </span>
                                        </MenuItem>
                                    </TextField>
                                    <br />
                                    <TextField
                                        required
                                        label="Email"
                                        type="email"
                                        fullWidth
                                        disabled={this.state.user_id}
                                        variant="standard"
                                        value={this.state.email}
                                        onChange={(e) => {
                                            this.setState({ email: e.target.value, emailerror: false, emailExistsError: false });
                                        }}
                                        onBlur={() => {
                                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                            const email = this.state.email.trim();

                                            if (email) {
                                                if (!emailRegex.test(email)) {
                                                    alert("Please enter a valid email address");
                                                    this.setState({ emailerror: true });
                                                } else if (this.state.existingEmails && this.state.existingEmails.includes(email.toLowerCase())) {
                                                    alert("This email already exists");
                                                    this.setState({ emailExistsError: true });
                                                }
                                            }
                                        }}
                                        error={Boolean(this.state.emailerror) || Boolean(this.state.emailExistsError)}
                                        helperText={
                                            this.state.emailerror
                                                ? "Invalid email address"
                                                : this.state.emailExistsError
                                                    ? "Email already exists"
                                                    : ""
                                        }
                                        sx={{
                                            '& label.MuiFormLabel-root': {
                                                '& .MuiInputLabel-asterisk': {
                                                    color: 'red',
                                                },
                                            },
                                        }}
                                        style={{ marginBottom: "10px" }}
                                    />
                                    <br />
                                    {this.state.usersList.length > 0 && (
                                        <FormControl fullWidth variant="standard" style={{ marginBottom: "10px" }}>
                                            {/* <InputLabel>Report To</InputLabel> */}
                                            <InputLabel>
                                                Report To&nbsp;
                                                <span style={{ fontWeight: 'normal', fontSize: '0.9rem', color: '#999' }}>
                                                    (Optional)
                                                </span>
                                            </InputLabel>

                                            <Select
                                                value={this.state.selectedUser}
                                                onChange={(e) => {
                                                    this.setState({ selectedUser: e.target.value, userError: false });
                                                }}
                                            >
                                                {this.state.usersList
                                                    .filter(user => user.user_email !== this.state.email)
                                                    .map((user) => (
                                                        <MenuItem key={user.id} value={user.user_email}>
                                                            {user.name} - ({user.user_email})

                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                            {this.state.userError && <Typography color="error">Please select a user</Typography>}
                                        </FormControl>
                                    )}


                                    <br />
                                    <span className="fieldmend"></span>
                                </div>
                                <div className="modal-footer align-btn-mobile" style={{ marginTop: '6%', display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                    <div type="button" className="btn allbtn" onClick={this.onclosemodel.bind(this)}>Cancel</div>
                                    <span className="hidden-xs hidden-sm">
                                    </span>
                                    <div type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null} className="btn btn-primary allbtn" onClick={this.onAddClickHandler.bind(this, 'add')}>{this.state.user_id ? "Edit" : "Add"}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''}
                {this.state.confirmWindow ? <div className="selfmodal fade in modal-dialog-centered" aria-hidden="false" data-backdrop="static" data-keyboard="false">
                    <div className="selfmodal-dialog " style={{ width: "50%" }}>
                        <div className="selfmodal-content ">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" onClick={this.confirmWindowClose.bind(this)}>&times;</button>
                                <h4 className="modal-title h3 text-center">Delete confirmation</h4>
                            </div>
                            <div className="modal-body modfields">
                                <span className="fa " >Delete icon</span>
                            </div>
                            <div className="modal-footer text-center  align-btn-mobile">
                                <button type="button" className="btn allbtn" onClick={this.confirmWindowClose.bind(this)}>Cancel</button>
                                <button type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null} className="btn btn-primary allbtn" onClick={this.ondeleteChangekHandler.bind(this)}>Delete</button>
                            </div>
                        </div>
                    </div>
                </div> : null}
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        successBarActivate: (data) => dispatch({ type: ActionTypes.SUCCESSBAR, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Users);
